import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/remediation')({
  beforeLoad: () => getTitleContextSlice('Remediation'),
  staticData: {
    owner: CodeOwner.Uvm,
  },
});
